var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"has-text-centered"},[_c('p',{staticClass:"is-size-7 mb-2"},[_vm._v("読み込み中にエラーが発生しました")]),_c('b-button',{attrs:{"label":"再読み込み","size":"is-small"},on:{"click":_vm.$attrs.trigger}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }